import { User } from "../../../../../interfaces/User";

export function createMailWithSubscribed(dataTableUsers: [], edition: any) {
  let baseURL = "https://outlook.office.com/mail/deeplink/compose?to=";

  let userEmails = dataTableUsers.map((user: User) => user.email);

  const facultyEmails = edition.sessions.flatMap((session: any) =>
    (session.faculties || []).map((f: any) => f.email),
  );

  const tutorEmails = edition.sessions.flatMap((session: any) =>
    (session.tutors || []).map((t: any) => t.email),
  );

  const allEmails = Array.from(
    new Set([...userEmails, ...facultyEmails, ...tutorEmails].filter(Boolean)),
  ).join(",");

  return baseURL + allEmails;
}
